import type { SVGProps } from "react";
const SvgHeadphones = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
    <path
      fill="url(#headphones_svg__a)"
      d="M28.125 53.125a6.25 6.25 0 0 0-6.25-6.25 6.25 6.25 0 0 0-6.25 6.25V75a6.25 6.25 0 0 0 6.25 6.25 6.25 6.25 0 0 0 6.25-6.25z"
    />
    <path
      fill="url(#headphones_svg__b)"
      d="M52.988 87.406c-1.497.253-5.506.935-7.003 1.191a4.69 4.69 0 0 0 1.572 9.247c1.496-.253 5.506-.934 7.003-1.19a4.69 4.69 0 0 0-1.572-9.248"
    />
    <path
      fill="url(#headphones_svg__c)"
      d="M87.5 50.866V43.75c0-20.678-16.822-37.5-37.5-37.5s-37.5 16.822-37.5 37.5v7.116c-1.86 1.084-3.125 3.078-3.125 5.384v15.625a6.25 6.25 0 0 0 6.25 6.25h.866a6 6 0 0 1-.582-1.356c-.022-.072-.046-.138-.065-.213A6.2 6.2 0 0 1 15.625 75V53.125c0-2.306 1.266-4.3 3.125-5.384V43.75C18.75 26.519 32.769 12.5 50 12.5s31.25 14.019 31.25 31.25v3.99a6.3 6.3 0 0 1 2.21 2.166c.04.066.071.138.112.206q.298.54.487 1.135c.038.122.082.237.113.362.119.488.203.991.203 1.516V75c0 1.966-.925 3.697-2.344 4.844v1.419a3.91 3.91 0 0 1-3.175 3.837L57.47 89.181c.456.588.794 1.282.925 2.066.153.91.025 1.797-.306 2.59l21.646-4.13a8.6 8.6 0 0 0 6.982-8.441v-3.6c2.29-.932 3.909-3.17 3.909-5.791V56.25c0-2.306-1.266-4.3-3.125-5.384Z"
    />
    <path
      fill="url(#headphones_svg__d)"
      d="M84.375 53.125a6.25 6.25 0 0 0-6.25-6.25 6.25 6.25 0 0 0-6.25 6.25V75a6.25 6.25 0 0 0 6.25 6.25 6.25 6.25 0 0 0 6.25-6.25z"
    />
    <path
      fill="url(#headphones_svg__e)"
      d="M50 7.813c19.816 0 35.938 16.121 35.938 35.937v8.016l.778.453c1.468.853 2.347 2.362 2.347 4.031v15.625a4.67 4.67 0 0 1-2.932 4.338l-.975.396v4.653a7.04 7.04 0 0 1-5.712 6.907L57.797 92.3l-.825.156-.325.775a3.1 3.1 0 0 1-2.353 1.882l-7 1.19a3.12 3.12 0 0 1-3.61-2.56c-.14-.821.05-1.652.532-2.334a3.1 3.1 0 0 1 2.025-1.272l3.084-.525 3.916-.665q.261-.043.518-.044c.947 0 1.87.46 2.466 1.231l.587.76.944-.181 21.388-4.082a5.474 5.474 0 0 0 4.444-5.372v-4.687l-2.544 2.056c-.853.694-1.863 1.06-2.919 1.06A4.693 4.693 0 0 1 73.437 75V53.125a4.693 4.693 0 0 1 4.688-4.688c.806 0 1.594.22 2.338.657l2.35 1.365V43.75c0-18.094-14.72-32.813-32.813-32.813S17.187 25.657 17.187 43.75v6.71l2.35-1.366a4.57 4.57 0 0 1 2.338-.657 4.693 4.693 0 0 1 4.688 4.688V75a4.693 4.693 0 0 1-4.688 4.688c-1.669 0-3.178-.879-4.031-2.347l-.453-.778h-1.766a4.693 4.693 0 0 1-4.688-4.688V56.25c0-1.669.879-3.178 2.347-4.031l.778-.453V43.75C14.063 23.934 30.184 7.812 50 7.812Zm0-1.563c-20.678 0-37.5 16.822-37.5 37.5v7.116c-1.86 1.084-3.125 3.078-3.125 5.384v15.625a6.25 6.25 0 0 0 6.25 6.25h.866c1.084 1.86 3.078 3.125 5.384 3.125a6.25 6.25 0 0 0 6.25-6.25V53.125a6.25 6.25 0 0 0-6.25-6.25c-1.144 0-2.203.331-3.125.866V43.75C18.75 26.519 32.769 12.5 50 12.5s31.25 14.019 31.25 31.25v3.99c-.922-.534-1.981-.865-3.125-.865a6.25 6.25 0 0 0-6.25 6.25V75a6.25 6.25 0 0 0 6.25 6.25c1.487 0 2.834-.54 3.906-1.406v1.419a3.91 3.91 0 0 1-3.175 3.837L57.47 89.181a4.69 4.69 0 0 0-3.703-1.837q-.387 0-.782.065c-1.497.253-5.506.935-7.003 1.191a4.69 4.69 0 0 0 1.569 9.247c1.497-.253 5.506-.934 7-1.19a4.67 4.67 0 0 0 3.531-2.82l21.647-4.13a8.6 8.6 0 0 0 6.981-8.441v-3.6c2.297-.932 3.916-3.17 3.916-5.791V56.25c0-2.306-1.266-4.3-3.125-5.384V43.75c0-20.678-16.822-37.5-37.5-37.5Z"
    />
    <defs>
      <linearGradient
        id="headphones_svg__a"
        x1={11.988}
        x2={31.762}
        y1={54.175}
        y2={73.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B66E" />
        <stop offset={1} stopColor="#00E98D" />
      </linearGradient>
      <linearGradient
        id="headphones_svg__b"
        x1={37.312}
        x2={40.017}
        y1={89.584}
        y2={101.113}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B66E" />
        <stop offset={1} stopColor="#00E98D" />
      </linearGradient>
      <linearGradient
        id="headphones_svg__c"
        x1={18.913}
        x2={84.309}
        y1={21.828}
        y2={87.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#006933" />
        <stop offset={1} stopColor="#00801E" />
      </linearGradient>
      <linearGradient
        id="headphones_svg__d"
        x1={68.237}
        x2={88.013}
        y1={54.175}
        y2={73.95}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00B66E" />
        <stop offset={1} stopColor="#00E98D" />
      </linearGradient>
      <linearGradient
        id="headphones_svg__e"
        x1={18.913}
        x2={84.309}
        y1={21.828}
        y2={87.225}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.6} />
        <stop offset={0.493} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.997} stopColor="#fff" stopOpacity={0.3} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgHeadphones;
